/** Dinheiro na tela. O servidor manda string com duas casas; aqui só formata. */

export function paraReais(valor: string | number): string {
  const n = typeof valor === 'number' ? valor : Number(valor);
  return n.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  });
}

/** Máscara enquanto se digita: `123456` vira `1.234,56`. */
export function mascararDinheiro(entrada: string): string {
  const d = entrada.replace(/\D/g, '').slice(0, 12);
  if (!d) return '';
  const n = Number(d) / 100;
  return n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/**
 * ⭐ **ENQUANTO SE DIGITA, os reais — 17/09/2026, pedido dele.** Os pontos de
 * milhar entram sozinhos; a vírgula, quem digita; até duas casas depois dela.
 * `100` fica `100` (não `1,00`, como a máscara de centavos fazia).
 *
 * ⚠️ `mascararDinheiro` continua existindo e continua recebendo CENTAVOS: é o
 * formatador de valores que vêm do servidor e das somas.
 */
export function digitarReais(entrada: string): string {
  const [int = '', ...resto] = entrada.split(',');
  const inteiro = int.replace(/\D/g, '').replace(/^0+(?=\d)/, '').slice(0, 12);
  const comPontos = inteiro.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return resto.length ? `${comPontos || '0'},${resto.join('').replace(/\D/g, '').slice(0, 2)}` : comPontos;
}

/** Ao sair do campo: `100` → `100,00`; `100,1` → `100,10`; `100,` → `100,00`. Vazio fica vazio. */
export function completarReais(entrada: string): string {
  if (!/\d/.test(entrada)) return '';
  const [int = '', dec = ''] = digitarReais(entrada).split(',');
  return `${int || '0'},${(dec + '00').slice(0, 2)}`;
}

/**
 * `1.234,56` → `1234.56`, que é o que a API espera. ⭐ Desde 17/09/2026 lê
 * também o que ainda não foi completado: `100` → `100.00`, `100,1` → `100.10`.
 * O que vem com vírgula e duas casas (tudo o que `mascararDinheiro` produz)
 * dá o mesmo resultado de antes.
 */
export function paraApi(mascarado: string): string {
  const [int = '', ...resto] = mascarado.split(',');
  const i = int.replace(/\D/g, '');
  const d = resto.join('').replace(/\D/g, '');
  if (!i && !d) return '';
  return `${String(Number(i || '0'))}.${(d + '00').slice(0, 2)}`;
}
